
export default function QRSection() {
  return (
    <section id="qr-section" className="py-16 sm:py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            500+ đại lý đã tham gia Liên Minh Du Lịch Mỹ
          </h2>
          <p className="text-xl sm:text-2xl text-blue-600 font-semibold">
            Bạn đã sẵn sàng?
          </p>
        </div>

        <div className="flex flex-col items-center">
          <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-md w-full">
            <div className="mb-5 sm:mb-6">
              <img 
                src="https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/a66e3bb00725d4bc1b06edee864da915.jpeg"
                alt="QR Code Zalo Liên Minh Du Lịch Mỹ"
                className="w-full h-auto rounded-lg"
              />
            </div>
            
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 mb-4">
                <i className="ri-qr-scan-2-line text-2xl sm:text-3xl text-blue-600"></i>
                <p className="text-base sm:text-lg font-semibold text-gray-900">
                  Quét mã QR
                </p>
              </div>
              
              <p className="text-sm sm:text-base text-gray-600 mb-5 sm:mb-6">
                Tham gia nhóm Zalo ngay để nhận thông tin mới nhất về chương trình đại lý và các ưu đãi độc quyền
              </p>

              <div className="bg-blue-50 rounded-lg p-4">
                <div className="flex items-start gap-3 text-left">
                  <i className="ri-checkbox-circle-fill text-blue-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Nhận ngay khi tham gia:</p>
                    <ul className="text-xs sm:text-sm text-gray-600 space-y-1">
                      <li>• Bộ tài liệu giới thiệu sản phẩm</li>
                      <li>• Cập nhật tour mới hàng tuần</li>
                      <li>• Hỗ trợ tư vấn 1-1 từ chuyên gia</li>
                      <li>• Kết nối với 500+ đại lý toàn quốc</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-8 text-center px-4">
            <p className="text-gray-500 text-xs sm:text-sm mb-3 sm:mb-4">
              Hoặc liên hệ trực tiếp qua Zalo
            </p>
            <a 
              href="https://zalo.me/g/bjwbgr958" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-5 sm:px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line text-lg sm:text-xl"></i>
              <span className="font-semibold text-sm sm:text-base">Chat ngay trên Zalo</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}